import { SET_REQUEST_ID } from "../actionTypes";

const initialState = {
  requestId: '',
  transactionId: '',
  paymentDueDate: '',
  applicationSubmittedDate: ''
};

export default function(state = initialState, action) {
  switch (action.type) {
    case SET_REQUEST_ID: {
      return {
        ...state,
        requestId:action.payload.requestId,
        transactionId:action.payload.transactionId,
        paymentDueDate: action.payload.paymentDueDate,
        applicationSubmittedDate: action.payload.applicationSubmittedDate
      };
    } 
    default:
      return state;
  }
}